import React from "react"
import get from "lodash/get"
import PropTypes from "prop-types"
import styled from "styled-components"
import filter from "lodash/filter"
import { findDOMNode } from "react-dom"
import ImageCompressor from "image-compressor.js"
import { connect } from "react-redux"

import config from "../Config"
import ImageZoomer from "./ImageZoomer"
import { fullPageLoader } from "../store/action"

const ImageZoomContainer = styled.div`
  display: flex;
  justify-content: center;
`

const ImgBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  position: relative;
`

const UploadImageContainer = styled.div`
  display: flex;
  position: absolute;
  bottom: 0px;
  margin-left: 35px;
`

const UploadImage = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
`

class MediaUpload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      files: this.props.data,
    }
  }

  onFileLoad = (e, file) => {
    let files = { ...this.state.files }
    files["file"] = e.target.result
    files["fileData"] = file
    this.setState({ files })
    this.props.onChange && this.props.onChange(files)
    this.props.fullPageLoader({ showFullPageLoading: false })
  }

  onInputChange = (e) => {
    const fileSize = get(e, "target.files[0].size")
    if (this.props.maxSize && fileSize && fileSize > this.props.maxSize) {
      alert("Limit exceeded. Maximum size 2MB")
      return
    }
    filter(
      e.target.files,
      (file) => file.type.match(this.props.fileTypeRegex) !== null
    ).forEach((file) => {
      this.props.fullPageLoader({ showFullPageLoading: true, opacity: 0 })
      let reader = new FileReader()
      const imageCompressor = new ImageCompressor()
      imageCompressor
        .compress(file, { convertSize: 1000000, quality: 0.6 })
        .then((result) => {
          // console.log("Before compress file-->>",file);
          // console.log("Afer compress file -->>",result);
          reader.onload = (e) => this.onFileLoad(e, result)
          reader.readAsDataURL(result)
          // Handle the compressed image file.
        })
        .catch((err) => {
          console.error("Error occur while compressing the image -->>", err)
          // Handle the error
        })
    })
  }

  componentDidMount() {
    findDOMNode(this.uploadInput).addEventListener(
      "change",
      this.onInputChange,
      false
    )
  }

  componentWillUnmount() {
    findDOMNode(this.uploadInput).removeEventListener(
      "change",
      this.onInputChange,
      false
    )
  }

  render() {
    const { style } = this.props

    return (
      <ImgBox style={{ ...style }}>
        <ImageZoomContainer>
          <ImageZoomer
            src={this.state.files && this.state.files.file}
            alt='image-preview'
            imgStyle={{
              borderRadius: "50%",
              width: 90,
              height: 90,
              backgroundColor: "lightgray",
            }}
          />
        </ImageZoomContainer>
        <UploadImageContainer>
          <UploadImage>
            <img
              src={`${config.MRBIDNWIN_S3_IMAGE_URL}/photo_edit.svg`}
              alt='profile-edit'
            />
            <input
              type='file'
              name='...'
              style={{
                opacity: 0,
                position: "absolute",
                height: 40,
                width: 40,
              }}
              ref={(ref) => {
                this.uploadInput = ref
              }}
              accept='image/*'
            />
          </UploadImage>
        </UploadImageContainer>
      </ImgBox>
    )
  }
}

MediaUpload.defaultProps = {
  style: {},
}

MediaUpload.propTypes = {
  onChange: PropTypes.func,
  maxSize: PropTypes.number,
  data: PropTypes.object,
}

export default (MediaUpload = connect(
  (state, ownProps) => {
    return {}
  },
  {
    fullPageLoader,
  }
)(MediaUpload))



// WEBPACK FOOTER //
// ./src/components/mediaUpload.js